import { z } from 'zod'
export const historySectionSchema = z.enum([
  'identity',
  'website',
  'venue',
  'ceremony',
  'photo',
  'beauty',
  'decor',
  'attire',
  'guests',
  'schedule',
  'music',
  'reception',
])
export const historyEntityResourceSchema = z.union([
  z.literal('budget'),
  z.templateLiteral([
    z.enum(['place', 'place-price', 'supplier', 'task', 'category', 'expense', 'payment', 'party']),
    ':',
    z.uuid(),
  ]),
  z.templateLiteral(['contact:', z.uuid(), ':', z.uuid()]),
])
/** Who made a change: a wedding member, or a guest through their personal link. */
export const HISTORY_SOURCES = ['member', 'personal-link'] as const
export type HistorySource = (typeof HISTORY_SOURCES)[number]
export const historyResourceSchema = z.union([historySectionSchema, historyEntityResourceSchema])
export type HistoryResource = z.infer<typeof historyResourceSchema>
export const saveDraftSchema = z.object({
  data: z.unknown().refine((value) => value !== undefined),
  expected: z.unknown().refine((value) => value !== undefined),
})
export const restoreRevisionSchema = z.object({
  expected: z.unknown().refine((value) => value !== undefined),
})
